
import Product from "./components/Product";
import CartItem from "./components/CartItem";
import { connect } from "react-redux";
import { add_to_cart } from "./redux/addToCart/action";
import { useEffect, useState } from "react";

function App({ products, carts }) {

   const [cartQty, setcartQty]= useState(0);
   const [cartPrice, setCartPrice] = useState(0);

   useEffect(() => {
    let count = 0; 
    carts.forEach((item) => {
      count += item.qty;
    })

    setcartQty(count);
   }, [carts, cartQty])

// Price Total 
   useEffect(() => {
    let priceArray = []; 
    carts.forEach((item) => {
      let count = item.price * item.qty;
      priceArray.push(count);
    })

    const sum = priceArray.reduce((partialSum, a) => partialSum + a, 0);
    setCartPrice(sum);
   }, [carts, cartPrice])
  
  return (
   
      <div class="bg-gray-50 h-full md:h-screen">
        <div class="grid place-items-center">
          <h1
            class="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4"
          >
            Shopping Cart
          </h1>
        </div>
        <div class="grid grid-cols-12 gap-6">
          <div
            class="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8"
          >
            {/* <Product name={'Asus Vivobook X515MA'} price={35500} quantity={20} />
            <Product name={'Dell E1916HV 18.5 Inch'} price={9300} quantity={35} />
            <Product name={'Canon Eos 4000D 18MP'} price={36500} quantity={72} /> */}
            {products.map((product) => (<Product key={product.id} id={product.id} name={product.name} price={product.price} quantity={product.quantity} />))}

          </div>
          <div
            class="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4"
          >
            <div
              class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
              {/* {products.map(({id, name, price, quantity}) => <CartItem key={id} id={id} name={name} price={price} quantity={quantity} /> )} */}
              {/* {carts.map((cartItem) => (<CartItem key={cart.id} cart={cart} />))} */}
              {carts.map((cartItem) => (<CartItem key={cartItem.id} id={cartItem.id} qty={cartItem.qty} name={cartItem.name} />))}
              <div
                class="flex justify-center items-center text-center"
              >
                <div class="text-xl font-semibold">
                  <p>Total Item</p>
                  <p class="text-5xl">
                    {
                      cartQty
                    }
                  </p>
                </div>
              </div>
            </div>
            <div
              class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
              <div
                class="flex justify-center items-center text-center"
              >
                <div class="text-xl font-semibold">
                  <p>Total Price</p>
                  <p class="text-5xl">{cartPrice}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   
  );
}

const mapStateToProps = (state, ownProps) => {
  console.log(ownProps);
  return {
      products: state.products,
      carts: state.cart
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add_to_cart: (value) => dispatch(add_to_cart(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
